<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        document.documentElement.classList.add('js-enabled');
        window.foucTimeout = setTimeout(function() {
            document.documentElement.classList.remove('js-enabled');
        }, 2000);
    </script>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#F8F9FA">
    <link rel="preload" as="font" href="fonts/Lato-Regular.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Lato-Bold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Fredoka-SemiBold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="image" href="images/photos/childplaying.webp" type="image/webp" fetchpriority="high">
    <title>Little Explorers Nursery | Day Nursery & Childcare in Anytown (AT1)</title>
    <link rel="icon" type="image/svg+xml" href="images/logo.svg">
    <meta name="description" content="A nurturing, home-from-home nursery in the heart of Anytown. Book a tour today.">
    <!-- 2026 AI Agent Discovery Links -->
    <link rel="alternate" type="text/plain" title="LLM Summary (Low Token)" href="/llms.txt">
    <link rel="alternate" type="text/plain" title="LLM Full Knowledge Base (High Token)" href="/llms-full.txt">
    <!-- Open Graph / Social Media -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://littleexplorersnursery.example.com/">
    <meta property="og:title" content="Little Explorers Nursery | Premium Day Nursery in Anytown (AT1)">
    <meta property="og:description" content="A nurturing, home-from-home early years setting in the heart of Anytown. We provide premium childcare, organic meals, and funded places. Book a tour today.">
    <meta property="og:image" content="https://littleexplorersnursery.example.com/images/og-image.jpg">
    <meta name="twitter:card" content="summary_large_image">
    <!-- Your CSS -->
    <link rel="stylesheet" href="css/style.css">
    <script type="module" src="js/lib/dotlottie/dotlottie-player.mjs"></script>
    
    <!-- 2026 Speculation Rules for Instant Navigation -->
    <script type="speculationrules">
    {
      "prerender": [{
        "source": "document",
        "where": {"href_matches": "/*"},
        "eagerness": "moderate"
      }]
    }
    </script>
    <script defer src="/vendor/gsap.min.js"></script>
    <script defer src="/vendor/ScrollTrigger.min.js"></script>
    <script type="module" src="/js/main.js"></script>
    <script type="module" src="/js/global-animations.js"></script>
    <script type="module" src="/js/index.js"></script>



    <!-- GEO / SEO Data (Top 5 keyword-rich reviews for AI Bots) -->
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "ChildCare",
      "name": "Little Explorers Nursery",
      "image": "https://littleexplorersnursery.example.com/images/logo.svg",
      "url": "https://littleexplorersnursery.example.com",
      "telephone": "+442079460123",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "13 Anytown Green",
        "addressLocality": "Anycity",
        "postalCode": "AT1 5LB",
        "addressCountry": "GB"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "51.5074",
        "longitude": "-0.1278"
      },
      "sameAs": [
        "https://www.facebook.com/example",
        "https://reports.ofsted.gov.uk/",
        "https://ratings.food.gov.uk/"
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "15"
      },
      "review": [
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Parent A" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5" },
          "reviewBody": "The staff are incredibly caring and my child has blossomed since starting here. They provide a wonderful mix of fun and learning."
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Parent B" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5" },
          "reviewBody": "A fantastic nursery with brilliant facilities. The outdoor play area is amazing and they always have engaging activities planned."
        },
        {
          "@type": "Review",
          "author": { "@type": "Person", "name": "Parent C" },
          "reviewRating": { "@type": "Rating", "ratingValue": "5" },
          "reviewBody": "We couldn't be happier with our choice. The team goes above and beyond, and the communication with parents is excellent."
        }
      ]
    }
    </script>
</head>
<body>



    <!-- MOBILE NAVBAR START -->
    <nav class="mobile-navbar" aria-label="Mobile top bar">
        <a href="/" class="mobile-logo-link">
            <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="mobile-logo" width="45" height="44" loading="eager" fetchpriority="high">
        </a>
        <button type="button" class="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded="false">
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </nav>



    <!-- MOBILE CURTAIN OVERLAY NAVIGATION -->
    <div class="mobile-menu-overlay" aria-hidden="true" style="display: none;">
        <nav class="mobile-overlay-nav">
            <ul class="mobile-overlay-list">
                <li><a href="/" class="mobile-overlay-link">Home</a></li>
                <li><a href="rooms" class="mobile-overlay-link">Our Rooms</a></li>
                <li><a href="staff" class="mobile-overlay-link">Our Team</a></li>
                <li><a href="fees" class="mobile-overlay-link">Fees & Info</a></li>
                <li><a href="contact" class="mobile-overlay-link cta-pill">Book a Tour</a></li>
            </ul>
        </nav>
    </div>
    <!-- MOBILE NAVBAR END -->



    <!-- DESKTOP NAVBAR START -->
    <header class="site-header">
        <div class="container header-inner">
            <a href="/" class="logo-link">
                <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="site-logo" width="61" height="60" loading="eager" fetchpriority="high">
            </a>
            <nav class="nav-links">
                <a href="/" class="active">Home</a>
                <a href="rooms">Our Rooms</a>
                <a href="staff">Our Team</a>
                <a href="fees">Fees & Info</a>
            </nav>
            <div class="header-cta">
                <a href="contact" class="btn btn-primary">Book a Tour</a>
            </div>
        </div>
    </header>
    <!-- DESKTOP NAVBAR END -->



    <!-- HERO SECTION START -->
    <main>
        <section class="hero">
            <div class="container hero-inner">
                
                <!-- Left Side: Text & Call to Action -->
                <div class="hero-content">
                    <!-- Playful shapes moved directly above the pill -->
                    <img src="images/animations/bouncing-shapes.svg" alt="" class="shapes-inline" width="120" height="43">
                    
                    <div class="badge-wrapper">
                        <span class="badge-pill">Welcoming new families</span>
                    </div>
                    <h1>A nurturing start in the heart of Anytown.</h1>
                    <p>Welcome to your child's home-from-home. Owned and managed by fully qualified Early Years teachers, we provide a warm, secure environment where your child can truly flourish.</p>
                    
                    <div class="hero-actions">
                        <span class="crayon-wrap">
                            <a href="contact" class="btn btn-primary btn-large">Arrange a Visit</a>
                            <!-- Hand-drawn SVG Arrow pointing at button -->
                            <svg class="crayon-svg arrow" viewBox="0 0 60 80" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
                                <path class="arrow-line" d="M 45,5 C 50,30 35,50 15,65" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path class="arrow-tip" d="M 25,50 L 15,65 L 30,70" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </span>
                        
                        <!-- Trust Signals / Badges -->
                        <div class="trust-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="trust-badge" width="108" height="60">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img src="images/svgs/Ofsted_Good_GP_Colour.svg" alt="Ofsted Good Provider" class="trust-badge ofsted-hero-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                </div>



                <!-- Right Side: Human Connection Carousel -->
                <div class="hero-image-wrapper">
                    <div class="hero-carousel hero-img">
                        <!-- Slide 1 -->
                        <div class="hero-slide active">
                            <img src="images/photos/childplaying.webp" alt="Nursery practitioner smiling and playing with a happy toddler" width="800" height="1000" fetchpriority="high">
                        </div>
                        <!-- Slide 2 -->
                        <div class="hero-slide">
                            <img src="images/photos/placeholder-1.webp" alt="Child concentrating on painting" width="800" height="1000" loading="lazy">
                        </div>
                        <!-- Slide 3 -->
                        <div class="hero-slide">
                            <img src="images/photos/placeholder-2.webp" alt="Cozy nursery environment" width="800" height="1000" loading="lazy">
                        </div>
                        <!-- Slide 4 -->
                        <div class="hero-slide">
                            <img src="images/photos/placeholder-3.webp" alt="Children learning through play" width="800" height="1000" loading="lazy">
                        </div>
                        
                        <!-- Frosted Glass Liquid Pagination -->
                        <div class="hero-pagination glass-pill">
                            <div class="liquid-worm"></div>
                            <button class="dot active" aria-label="Go to slide 1"></button>
                            <button class="dot" aria-label="Go to slide 2"></button>
                            <button class="dot" aria-label="Go to slide 3"></button>
                            <button class="dot" aria-label="Go to slide 4"></button>
                        </div>
                    </div>
                    <div class="decor-shape"></div>
                </div>



            </div>
        </section>
        <!-- HERO SECTION END -->



        <!-- LOGISTICS BAR START -->
        <section class="logistics-bar">
            <div class="container">
                 <div class="logistics-grid">
                    <div class="logistics-item">
                        <div class="icon-circle">
                            <div class="mask-icon" style="-webkit-mask-image: url('images/icons/cutesun.svg'); mask-image: url('images/icons/cutesun.svg'); width: 28px; height: 28px;"></div>
                        </div>
                        <div>
                            <h2>Opening Hours</h2>
                            <p>Mon - Fri, 8:00am - 6:00pm</p>
                        </div>
                    </div>
                    <div class="logistics-item">
                        <div class="icon-circle">
                            <div class="mask-icon" style="-webkit-mask-image: url('images/icons/teddybear.svg'); mask-image: url('images/icons/teddybear.svg'); width: 28px; height: 28px;"></div>
                        </div>
                        <div>
                            <h2>Ages Accepted</h2>
                            <p>3 months to 5 years</p>
                        </div>
                    </div>
                    <div class="logistics-item">
                        <div class="icon-circle">
                            <div class="mask-icon" style="-webkit-mask-image: url('images/icons/signpost.svg'); mask-image: url('images/icons/signpost.svg'); width: 28px; height: 28px;"></div>
                        </div>
                        <div>
                            <h2>Location</h2>
                            <p><a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- LOGISTICS BAR END -->

        <!-- WHY CHOOSE US START -->
        <section class="usps section-padding">
            <div class="container">
                
                <!-- Floating Background Lottie (Moved inside 1200px container) -->
                <div class="decor-lottie teddy-bg" aria-hidden="true" data-nosnippet>
                    <dotlottie-player src="images/animations/teddy.lottie" speed="0.5" autoplay loop></dotlottie-player>
                </div>



                <div class="section-header text-center">
                    <h2>Why 
                        <span class="crayon-wrap">
                            families
                            <!-- Hand-drawn SVG circle path -->
                            <svg class="crayon-svg circle" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 10,20 C 10,5 90,5 90,20 C 90,35 15,38 15,20" fill="none" stroke="var(--color-accent)" stroke-width="3" stroke-linecap="round"></path>
                            </svg>
                        </span> 
                        choose us
                    </h2>
                    <p>We blend the warmth of a loving home with the rich, stimulating environment of a premium early years setting.</p>
                </div>
                
                <div class="usp-grid">
                    <div class="usp-card">
                        <div class="usp-icon">
                            <div class="mask-icon" style="-webkit-mask-image: url('images/icons/househeart.svg'); mask-image: url('images/icons/househeart.svg'); width: 32px; height: 32px;"></div>
                        </div>
                        <h3>A True Home-from-Home</h3>
                        <p>Set within a beautifully converted house, our nursery provides a warm, secure environment. We deliberately keep our <strong class="tldr-stat">numbers small</strong> so that every child receives the <strong class="tldr-stat">individual attention</strong> and love they deserve from our dedicated team.</p>
                    </div>
                    <div class="usp-card">
                        <div class="usp-icon">
                            <div class="mask-icon" style="-webkit-mask-image: url('images/icons/sprout.svg'); mask-image: url('images/icons/sprout.svg'); width: 32px; height: 32px;"></div>
                        </div>
                        <h3>Enriched Experiences</h3>
                        <p>We far exceed standard frameworks by providing specialist sessions at <strong class="tldr-stat">no extra cost</strong>. Your child will enjoy <strong class="tldr-stat">weekly yoga, French lessons</strong> with puppets, drama with our music specialist, and creative projects with our resident artist.</p>
                    </div>
                    <div class="usp-card">
                        <div class="usp-icon">
                            <div class="mask-icon" style="-webkit-mask-image: url('images/icons/carrot.svg'); mask-image: url('images/icons/carrot.svg'); width: 32px; height: 32px;"></div>
                        </div>
                        <h3>Organic & Nutritious</h3>
                        <p>Our <strong class="tldr-stat">5-star rated kitchen</strong> prepares fresh meals daily using <strong class="tldr-stat">organic</strong> bread, meat, vegetables, and whole milk. We even serve fresh seasonal fish delivered directly to the nursery from a local Anytown fishmonger.</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- WHY CHOOSE US END -->



        <!-- GALLERY SECTION START -->
        <section class="gallery section-padding">
            <div class="container">
                <div class="section-header text-center">
                    <h2>A 
                        <span class="crayon-wrap">
                            Peek Inside
                            <!-- Hand-drawn SVG underline path -->
                            <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h2>
                    <p>Bright, purposeful spaces designed to inspire awe and wonder at every turn.</p>
                </div>



               <div class="gallery-grid">
                    <div class="gallery-item img-large">
                        <img src="images/photos/inside.webp" alt="Bright and spacious main nursery playroom with orange pillars" width="1200" height="800" loading="lazy" decoding="async">
                    </div>
                    <div class="gallery-item img-small-1">
                        <!-- AI Messy Play Image -->
                        <img src="images/photos/hands.webp" alt="Child's hands covered in colourful paint" width="600" height="600" loading="lazy" decoding="async">
                    </div>
                    <div class="gallery-item img-small-2">
                        <img src="images/photos/garden.webp" alt="Little Explorers Nursery garden" width="600" height="600" loading="lazy" decoding="async">
                    </div>
                </div>
            </div>
        </section>
        <!-- GALLERY SECTION END -->



         <!-- OVERLAY NAV BLOCKS START -->
        <section class="overlay-nav-bar">
            <div class="container">
                <div class="nav-blocks-wrapper">
                    <!-- Subtle dark tint so the white boxes pop -->
                    <div class="nav-blocks-overlay"></div>
                    
                    <div class="nav-blocks-grid">
                        <a href="rooms" class="nav-block-item">
                            <h3>Our Rooms</h3>
                        </a>
                        <a href="staff" class="nav-block-item">
                            <h3>Our Team</h3>
                        </a>
                        <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer" class="nav-block-item">
                            <h3>Location</h3>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <!-- GALLERY SECTION END -->



        <!-- TESTIMONIALS FEATURE START -->
        <section class="testimonials section-padding">
            
            <div class="container">
                <div class="section-header text-center">
                    <h2>Loved by Anytown 
                        <span class="crayon-wrap">
                            Families
                            <!-- Hand-drawn SVG highlight path -->
                            <svg class="crayon-svg highlight" viewBox="0 0 140 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 20,20 C 50,17 90,23 120,20" fill="none" stroke="#F6CD99" stroke-width="22" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h2>
                    
                    <div class="rating-block">
                        <div class="stars-svg">
                            <span class="mask-icon icon-star icon-md"></span>
                            <span class="mask-icon icon-star icon-md"></span>
                            <span class="mask-icon icon-star icon-md"></span>
                            <span class="mask-icon icon-star icon-md"></span>
                            <span class="mask-icon icon-star icon-md"></span>
                        </div>
                    </div>
                    
                    <p style="max-width: 600px; margin: 0 auto;">Childcare is built entirely on trust. We are incredibly proud of the relationships we've built with our parents and the honest feedback they share about their child's journey with us.</p>
                    
                    <div style="margin-top: 2rem;">
                        <a href="https://www.facebook.com/Thelittleexplorersnursery" target="_blank" rel="noopener noreferrer" class="btn btn-primary" style="background-color: #1877F2; border: none; box-shadow: 0 4px 14px rgba(24, 119, 242, 0.3); gap: 0.5rem;">
                            <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                            <span class="fb-btn-desktop">Read all our reviews on Facebook</span>
                            <span class="fb-btn-mobile">Read our reviews</span>
                        </a>
                    </div>
                </div>
            </div>



            <div class="slider-track-container">
                <div id="cards-container" class="review-track">
                    
                    <!-- Card 1 -->
                    <div class="feature-card">
                        <div class="quote-mark-bg" data-nosnippet>"</div>
                        <div class="quote-content">
                            <p class="feature-quote">"The staff are incredibly caring and my child has blossomed since starting here. They provide a wonderful mix of fun and learning."</p>
                        </div>
                        <div class="dynamic-btn-container" style="flex-grow: 1;"></div>
                        <div class="parent-info">
                            <div class="parent-avatar">A</div>
                            <div class="parent-details">
                                <strong class="parent-name">Parent A</strong>
                                <span>Google Review</span>
                            </div>
                            <div class="stars-svg">
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                            </div>
                        </div>
                    </div>



                    <!-- Card 2 -->
                    <div class="feature-card">
                        <div class="quote-mark-bg" data-nosnippet>"</div>
                        <div class="quote-content">
                            <p class="feature-quote">"A fantastic nursery with brilliant facilities. The outdoor play area is amazing and they always have engaging activities planned."</p>
                        </div>
                        <div class="dynamic-btn-container" style="flex-grow: 1;"></div>
                        <div class="parent-info">
                            <div class="parent-avatar">B</div>
                            <div class="parent-details">
                                <strong class="parent-name">Parent B</strong>
                                <span>Google Review</span>
                            </div>
                            <div class="stars-svg">
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                            </div>
                        </div>
                    </div>



                    <!-- Card 3 -->
                    <div class="feature-card">
                        <div class="quote-mark-bg" data-nosnippet>"</div>
                        <div class="quote-content">
                            <p class="feature-quote">"We couldn't be happier with our choice. The team goes above and beyond, and the communication with parents is excellent."</p>
                        </div>
                        <div class="dynamic-btn-container" style="flex-grow: 1;"></div>
                        <div class="parent-info">
                            <div class="parent-avatar">C</div>
                            <div class="parent-details">
                                <strong class="parent-name">Parent C</strong>
                                <span>Google Review</span>
                            </div>
                            <div class="stars-svg">
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                                <span class="mask-icon icon-star icon-sm"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Slider Controls Centered Under Track -->
                <div class="slider-controls track-controls">
                    <button class="control-btn prev-btn" aria-label="Previous review">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                    </button>
                    <button class="control-btn next-btn" aria-label="Next review">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </button>
                </div>
            </div>
            </div>
        </section>
        <!-- TESTIMONIALS FEATURE END -->



        <!-- PRE-FOOTER CTA START -->
        <section class="pre-footer section-padding text-center">
            <div class="container">
                <h2>Experience our world for yourself</h2>
                <p>We would love to show you around our beautiful spaces and answer any questions you have about your child's early years journey.</p>
                <a href="contact" class="btn btn-primary btn-large">Book a Personal Tour</a>
            </div>
        </section>
        <!-- PRE-FOOTER CTA END -->



        <!-- FOOTER START -->
        <footer class="site-footer">
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col brand-col">
                        <h3 class="footer-logo-text"><span translate="no">Little Explorers Nursery</span></h3>
                        <p>A nurturing, home-from-home early years setting in the heart of Anytown, Anycity.</p>
                        <div class="footer-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="footer-badge-img" width="160" height="80">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Read our Ofsted Report">
                                <img loading="lazy" src="images/svgs/Ofsted_Good_GP_White.svg" alt="Ofsted Good Provider" class="ofsted-footer-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                    <div class="footer-col links-col">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="rooms">Our Rooms</a></li>
                            <li><a href="staff">Our Team</a></li>
                            <li><a href="fees">Fees & Funding</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                    </div>
                    <div class="footer-col contact-col">
                        <h4>Get in Touch</h4>
                        <address>
                            <ul>
                                <li><strong>A:</strong> <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></li>
                                <li><strong>T:</strong> <a href="tel:+442079460123">020 7946 0123</a></li> 
                                <li><strong>E:</strong> <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a></li>
                            </ul>
                        </address>
                        <h4 class="hours-title">Opening Hours</h4>
                        <p class="hours-text"><span>Mon - Fri: 8:00am - 6:00pm</span><span>Sat - Sun: Closed</span></p>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>&copy; <span id="current-year"></span> All Rights Reserved - <a href="https://selcreative.co.uk/" target="_blank" rel="noopener noreferrer">SEL Creative</a></p>
                    <div class="legal-links">
                        <a href="/privacy">Privacy Policy</a>
                        <span class="divider">|</span>
                        <a href="/safeguarding">Safeguarding Policy</a>
                    </div>
                </div>
            </div>
        </footer>
        <!-- FOOTER END -->



    </main> <!-- Make sure it is OUTSIDE of this tag! -->



    <!-- REVIEW MODAL OVERLAY -->
    <div id="review-modal" class="review-modal-overlay" aria-hidden="true" style="display: none;">
        <div class="modal-dialog-wrapper">
            <button class="close-modal-btn" aria-label="Close modal">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
            <div class="review-modal-content">
                <div class="modal-quote-bg" data-nosnippet>"</div>
                <div class="modal-body">
                    <p id="modal-quote" class="modal-quote-text"></p>
                </div>
            </div>
        </div>
    </div>



</body>
</html>

